import i18nFactory from '@yandex-int/i18n';
import React from 'react';

import { Loader } from '../../components/Loader/Loader';
import { Bem } from '../../service/Bem/Bem';
import { BatchesList } from '../BatchesList/BatchesList';
import { TriState } from '../BatchesList/typings';
import { CanvasFooter } from '../CanvasFooter/CanvasFooter';
import { Html5Filter } from '../Html5Filter/Html5Filter';

import './Html5Creatives.css';
import * as keyset from './Html5Creatives.i18n';
import { Html5CreativesProps } from './typings';

const i18n = i18nFactory(keyset);

const BLOCK = 'html5-creatives';

export class Html5Creatives extends React.PureComponent<Html5CreativesProps> {
    componentDidMount(): void {
        if (this.props.needRefresh) {
            this.props.loadItems(
                0,
                this.props.filter.order,
                this.props.filter.creativeSizes,
                this.props.filter.filterText
            );
        }
    }

    render() {
        const submitEnabled =
            this.props.batchesList.collection.batches.filter(item =>
                [TriState.TRUE, TriState.INDETERMINATE].includes(item.selected)
            ).length > 0;

        return (
            <div className={Bem.cls(BLOCK)}>
                {this.props.isBusy && <Loader size={'s'} />}
                <Html5Filter
                    {...this.props.filter}
                    applySizesFilter={this.props.applySizesFilter}
                    loadItems={this.props.loadItems}
                />
                <BatchesList
                    cls={Bem.cls(BLOCK, 'list')}
                    {...this.props.batchesList}
                    isBusy={this.props.isBusy}
                    filteredSizes={this.props.filter.creativeSizes}
                    showDeleteConfirm={this.props.showDeleteConfirm}
                    showCreativesSelector={this.props.showCreativesSelector}
                    toggleSizesSelection={this.props.toggleSizesSelection}
                    submitSizesSelection={this.props.submitSizesSelection}
                    hideCreativesSelector={this.props.hideCreativesSelector}
                    hideDeleteConfirm={this.props.hideDeleteConfirm}
                    delete={this.props.delete}
                    setSelection={this.props.setSelection}
                    saveName={this.props.saveName}
                    load={this.onLoad}
                />
                <CanvasFooter
                    cls={Bem.cls(BLOCK, 'footer')}
                    submitEnabled={submitEnabled}
                    submitVisible={true}
                    submitLabel={i18n('add-creatives')}
                    cancelLabel={i18n('cancel-and-return')}
                    error={this.props.error}
                    hideError={this.props.hideError}
                    submit={this.onSubmit}
                    cancel={this.props.cancel}
                />
            </div>
        );
    }

    private onSubmit = () => {
        this.props.submit(this.props.onCreativesSelect);
    };

    private onLoad = (offset: number) => {
        this.props.loadItems(
            offset,
            this.props.filter.order,
            this.props.filter.creativeSizes,
            this.props.filter.filterText
        );
    };
}
